import { resolve, relative, isAbsolute, sep } from 'node:path';
import { PathSecurityError } from '@vexalyn/shared';

export function resolveSafePath(workspaceRoot: string, requestedPath: string): string {
  const root = resolve(workspaceRoot);
  const resolved = resolve(root, requestedPath);
  const relativePath = relative(root, resolved);
  if (relativePath === '..' || relativePath.startsWith(`..${sep}`) || isAbsolute(relativePath)) {
    throw new PathSecurityError(requestedPath);
  }
  return resolved;
}